// extracted by mini-css-extract-plugin
export default {"r_l":"_0da6a3d09b _3fd7f2de28","t":"_9b751ad30d"};